export const mutation_add_allegato = `
mutation addAllegato($tenantId: String!, $entityType: String!, $entityId: Int!, $fileName: String!, $fileType: String!, $fileUrl: String!, $displayedName: String!) {
    insert_allegato_one(object: {TenantId: $tenantId, EntityType: $entityType, EntityId: $entityId, FileName: $fileName, FileType: $fileType, FileUrl: $fileUrl, DisplayedName: $displayedName}) {
        Id
        EntityType
        EntityId
        FileName
        FileType
        FileUrl
        DisplayedName
        CreatedOn
        ModifiedOn
        }
}`;
export const mutation_delete_allegato = `
mutation deleteAllegato($id: Int!) {
    delete_allegato(where: {Id: {_eq: $id}}) {
        affected_rows
    }
}`;
export const mutation_delete_allegato_fromStorage = `
mutation deleteAttachment($fileName: String!) {
    deleteAttachment(fileName: $fileName) {
        message
        success
    }
}`;
export const mutation_uploadAllegato = `
mutation uploadAttachment($tenantId: String!, $aziendaId: Int!, $entityType: String!, $dataInput : UploadAllegatoInput!) {
    uploadAttachment(tenantId: $tenantId, aziendaId: $aziendaId, entityType: $entityType, dataInput: $dataInput) {
        file_path
        file_name
    }
}`;
export const mutation_deleteAllegato = `
mutation deleteAllegato($tenantId:String!, $aziendaId:Int!, $allegatoId:Int!){
    deleteAttachment(tenantId: $tenantId, aziendaId: $aziendaId, allegatoId: $allegatoId) {
        success
        message
    }
}`;